import { ISubscriptionItem } from "@/api/types/subscription";
import { SubscriptionHistoryData } from "./type";

export const createSubscriptionData = (subscription: ISubscriptionItem): SubscriptionHistoryData => {
    return {
        id: subscription.id,
        planName: subscription.ml_title.en, // Use English title from ml_title
        status: subscription.status,
        startDate: subscription.startAt,
        endDate: subscription.endAt,
        paymentStatus: subscription.isActive ? "success" : "failed", // Map isActive to payment status
        paymentDate: subscription.createdAt, // Use createdAt as payment date
        source: subscription.source,
        autoRenewing: subscription.autoRenewing,
        createdAt: subscription.createdAt,
        updatedAt: subscription.updatedAt,
    };
};
